"use client";

import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import ClosureMatrixForm from "./ClosureMatrixForm";
import ClosureMatrixTable from "./ClosureMatrixTable";
import OwnerGroup from "../components/OwnerGroup";
import { useGlobalState } from "../utils/GlobalStateContext";

function ClosureMatrix() {
  const [open, setOpen] = useState(false);
  const { state: globalState } = useGlobalState();
  const { ownerGroups } = globalState;

  const [ownerGroup, setOwnerGroup] = useState();

  useEffect(() => {
    if (ownerGroups && ownerGroups.length > 0) {
      setOwnerGroup(ownerGroups[0].id);
    }
  }, [ownerGroups]);

  const handleOwnerGroupChange = (event) => {
    setOwnerGroup(event.target.value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Paper elevation={6}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem', alignItems: 'center', justifyContent: 'flex-start', marginBottom: '2rem', marginLeft: 'auto', minHeight: '80px' }}>
          <p style={{ fontSize: '1.25rem', marginLeft: '2rem', marginBottom: '2rem', alignSelf: 'center' }}>My ClosureMatrix</p>
          {ownerGroups && (
            <>
              <span style={{ margin: '2rem', marginLeft: 'auto', height: '1.75rem', display: 'flex', alignItems: 'center' }}>Select Owner Group</span>
              <OwnerGroup
                handleSelection={handleOwnerGroupChange}
                selectedValue={ownerGroup}
                options={ownerGroups}
                style={{ alignSelf: 'center' }}
              />
            </>
          )}
          <Button
            style={{ margin: '2rem', alignSelf: 'center' }}
            variant="contained"
            onClick={handleClickOpen}
            startIcon={<AddIcon />}
          >
            Create New ClosureMatrix
          </Button>
        </div>
      </Paper>
      <ClosureMatrixTable ownerGroup={ownerGroup} />
      <ClosureMatrixForm open={open} handleClose={handleClose} ownerGroup={ownerGroup} />
    </>
  );
}

export default ClosureMatrix;
